import React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "./utils";

export const Skeleton = ({ className, ...props }) => (
  <div aria-hidden="true" className={cn("tw-animate-d2c-pulse tw-rounded-md tw-bg-muted", className)} {...props} />
);

export const Separator = ({ className, orientation = "horizontal", ...props }) => (
  <SeparatorPrimitive.Root
    orientation={orientation}
    className={cn("tw-shrink-0 tw-bg-border", orientation === "horizontal" ? "tw-h-px tw-w-full" : "tw-h-full tw-w-px", className)}
    {...props}
  />
);

export const Label = React.forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn("tw-m-0 tw-font-sans tw-text-sm tw-font-medium tw-leading-5 tw-text-foreground", className)}
    {...props}
  />
));
Label.displayName = "Label";

// A callout box for notes and alerts. tone: info, warning, danger, success, neutral.
const CALLOUT = {
  info: "tw-border-blue-200 tw-bg-blue-50 tw-text-blue-900",
  warning: "tw-border-amber-200 tw-bg-amber-50 tw-text-amber-900",
  danger: "tw-border-red-200 tw-bg-red-50 tw-text-red-800",
  success: "tw-border-emerald-200 tw-bg-emerald-50 tw-text-emerald-900",
  neutral: "tw-border-border tw-bg-muted tw-text-foreground",
};
export const Callout = ({ tone = "info", icon: Icon, className, children, action, ...props }) => (
  <div
    className={cn("tw-flex tw-items-start tw-gap-3 tw-rounded-lg tw-border tw-px-4 tw-py-3 tw-text-sm tw-leading-5", CALLOUT[tone], className)}
    {...props}
  >
    {Icon && <Icon className="tw-mt-0.5 tw-size-4 tw-shrink-0" aria-hidden="true" />}
    <div className="tw-min-w-0 tw-flex-1">{children}</div>
    {action && <div className="tw-shrink-0">{action}</div>}
  </div>
);
